<template>
    <transition name="menu">
        <section v-if="!dismissSideMenu">
            <div class="side_menu_wrapper">
                <ul class="side_menu_items">
                    <li v-if="isGrantedPermission('OperationalView')" class="side_menu_link" @click="showSubItems('operations')">
                        <span class="icon material-icons">
                            insights
                        </span>
                        <span class="item_label">
                            {{ $t("sideMenu.operationalView") }}
                        </span>
                        <span class="icon material-icons sub_item_indicator" :class="{ sub_item_indicator_open: showOperationItems }">
                            chevron_right
                        </span>
                    </li>
                    <transition name="sub-menu">
                        <div v-show="showOperationItems" class="sub_settings_wrapper">
                            <ul class="sub_settings_items">
                                <router-link v-if="isGrantedPermission('DashboardEngagement')" to="/operational-view/operational" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("operationalView.operationalAnalysis") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('DashboardBrand')" to="/operational-view/brand" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("operationalView.brandAnalysis") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('DashboardMt')" to="/operational-view/mt" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("operationalView.mtAnalysis") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('ReportOperations')" to="/operational-reports/info" @click="closeSubItems" class="side_menu_link">
                                    <li> {{ $t("operationalView.operationTrackingManagerDashboard") }}</li>
                                </router-link>
                            </ul>
                        </div>
                    </transition>
                    <router-link v-if="isGrantedPermission('MyReports')" to="/reports" class="side_menu_link">
                        <li>
                            <span class="icon material-icons">
                                data_usage
                            </span>
                            <span class="item_label">
                                {{ $t("sideMenu.analytics") }}
                            </span>
                        </li>
                    </router-link>
                    <router-link v-if="isGrantedPermission('Monitoring')" to="/feeds"  @click="closeSubItems" class="side_menu_link">
                        <li>
                            <span class="icon material-icons">
                                forum
                            </span>
                            <span class="item_label">
                                {{ $t("feed.screenName") }}
                            </span>
                        </li>
                    </router-link>
                    <router-link v-if="isGrantedPermission('SniffDeck')" to="/sniffdeck" class="side_menu_link">
                        <li>
                            <span class="icon material-icons">
                                radio_button_checked
                            </span>
                            <span class="item_label">
                                Sniffdeck
                            </span>
                        </li>
                    </router-link>
                    <router-link v-if="isGrantedPermission('Engagement')" to="/operations" class="side_menu_link">
                        <li>
                            <span class="icon material-icons">
                                comment
                            </span>
                            <span class="item_label">
                                {{ $t("sideMenu.engagement") }}
                            </span>
                        </li>
                    </router-link>
                    <li v-if="isAnyGrantedPermission(['AlarmAdmin', 'AlarmIndividual'])" class="side_menu_link" @click="showSubItems('alarms')">
                        <span class="icon material-icons">
                            notification_important
                        </span>
                        <span class="item_label">
                            {{ $t("sideMenu.alarmManagement") }}
                        </span>
                        <span class="icon material-icons sub_item_indicator" :class="{ sub_item_indicator_open: showAlarmItems }">
                            chevron_right
                        </span>
                    </li>
                    <transition name="sub-menu">
                        <div v-show="showAlarmItems" class="sub_settings_wrapper">
                            <ul class="sub_settings_items">
                                <router-link v-if="isGrantedPermission('AlarmAdmin')" :to="alarmAdministrationLink" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("alarm.alarmAdministrationPanel") }}</li>
                                </router-link>
                                <router-link v-if="isAnyGrantedPermission(['AlarmAdmin', 'AlarmIndividual'])" :to="individualAlarmsLink" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("alarm.individualAlarmPanel") }}</li>
                                </router-link>
                            </ul>
                        </div>
                    </transition>
                    <li class="side_menu_link" @click="showSubItems('settings')">
                        <span class="icon material-icons">
                            settings
                        </span>
                        <span class="item_label">
                            {{ $t("sideMenu.settings") }}
                        </span>
                        <span class="icon material-icons sub_item_indicator" :class="{ sub_item_indicator_open: showSettingsItems }">
                            chevron_right
                        </span>
                    </li>
                    <transition name="sub-menu">
                        <div v-show="showSettingsItems" class="sub_settings_wrapper">
                            <ul class="sub_settings_items">
                                <router-link v-if="isGrantedPermission('BusinessAdministration')" to="/admin-panel/info" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("sideMenu.administrationPanel") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('ReportOperations')" to="/customer-management/info" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("sideMenu.customerManagement") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('PermissionOperations')" to="/permission/info" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("sideMenu.permissions") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('SuperUserCheck')" to="/super-user-operation/info" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("sideMenu.superUserActions") }}</li>
                                </router-link>
                            </ul>
                        </div>
                    </transition>
                    <li class="side_menu_link" @click="showSubItems('training')">
                            <span class="icon material-icons">
                                help_center
                            </span>
                            <span class="item_label">
                                {{ $t("sideMenu.trainingDocs") }}
                            </span>
                            <span class="icon material-icons sub_item_indicator" :class="{ sub_item_indicator_open: showTrainingItems }">
                                 chevron_right
                            </span>
                    </li>
                    <transition name="sub-menu">
                        <div v-show="showTrainingItems" class="sub_settings_wrapper">
                            <ul class="sub_settings_items">
                                <router-link v-if="isGrantedPermission('OperationalView')" to="/faq/dashboard" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.overView") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('Monitoring')" to="/faq/monitoring" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.monitoring") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('Engagement')" to="/faq/engagement" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.operation") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('BusinessAdministration') || isGrantedPermission('ReportOperations') || isGrantedPermission('PermissionOperations')" to="/faq/admin" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.admin") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('MyReports')" to="/faq/analysis" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.analysis") }}</li>
                                </router-link>
                                <router-link v-if="isGrantedPermission('IsExecutiveDashboard')" to="/faq/executivedashboard" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.executivedashboard") }}</li>
                                </router-link>
                                <router-link to="/faq/general" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.general") }}</li>
                                </router-link>
                                <router-link to="/faq/report" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.reports") }}</li>
                                </router-link>
                                <router-link to="/faq/usermanuals" @click="closeSubItems" class="side_menu_link">
                                    <li>{{ $t("training.usermanuals") }}</li>
                                </router-link>
                            </ul>
                        </div>
                    </transition>
                    <router-link v-if="isGrantedPermission('IsExecutiveDashboard')"  to="/executive" class="side_menu_link">
                        <li>
                            <span class="icon material-icons">
                                dashboard 
                            </span>
                            <span class="item_label">
                                Executive 
                            </span>
                        </li>
                    </router-link>
                    <router-link v-if="isAnyGrantedPermission(['AnswerApproved1','AnswerApproved2'])" to="/reply-approval" class="side_menu_link">
                        <li>
                            <span class="icon material-icons">
                                pending_actions
                            </span>
                            <span class="item_label">
                                {{ $t("sideMenu.disasterCrisisApprove") }}
                            </span>
                        </li>
                    </router-link>
                </ul>
            </div>
        </section>
    </transition>
    <transition name="toggle-button">
        <div v-if="!dismissSideMenu" class="menu_button toggle">
            <span class="icon material-icons" @click="hideSideMenu">
                menu_open
            </span>
        </div>
        <div v-else class="toggle">
            <span class="icon material-icons" @click="hideSideMenu">
                menu
            </span>
        </div>
    </transition>
</template>

<script>
export default {
    inject: [
        "isGrantedPermission", 
        "isAnyGrantedPermission", 
        "isAllGrantedPermission"
    ],
    data() {
        return {
            showAlarmItems: false, 
            dismissSideMenu: false, 
            showSettingsItems: false, 
            showOperationItems: false, 
            sideMenuAnimationInterval: null,
            showTrainingItems:false
        }
    },
    computed: {
        alarmAdministrationLink() {
            return { name: "alarms", query: { zone: "admin" }};
        },
        individualAlarmsLink() {
            return { name: "alarms", query: { zone: "individual" }};
        }
    },
    methods: {
        hideSideMenu() {
            this.dismissSideMenu = !this.dismissSideMenu;

            this.$store.dispatch("changeSideMenuState", this.dismissSideMenu);
        },
        showSubItems(menuItem) {
            if (menuItem == "settings") {
                this.showSettingsItems = !this.showSettingsItems;
                this.showAlarmItems = false;
                this.showTrainingItems = false;
                this.showOperationItems = false;
            } else if (menuItem == "alarms") {
                this.showAlarmItems = !this.showAlarmItems;
                this.showSettingsItems = false;
                this.showTrainingItems = false;
                this.showOperationItems = false;
            } else if (menuItem == "operations") {
                this.showOperationItems = !this.showOperationItems;
                this.showAlarmItems = false;
                this.showSettingsItems = false;
                this.showTrainingItems = false;
            }else if(menuItem == "training"){
                this.showTrainingItems = !this.showTrainingItems;
                this.showAlarmItems = false;
                this.showSettingsItems = false;
                this.showOperationItems = false;
            }
        },
        closeSubItems() {
            this.showAlarmItems = false;
            this.showSettingsItems = false;
            this.showOperationItems = false;
            this.showTrainingItems = false;
        },
        navigateExternalOperationalView() {
            window.open(process.env.VUE_APP_OLD_SNIFFER_API, "_blank");
        }
    }
}
</script>

<style scoped>
section {
    margin-top: 4.5rem;
    vertical-align: top;
    display: inline-block;
    height: calc(100vh - 4.5rem);
}

.side_menu_wrapper {
    z-index: 10;
    height: 100%;
    position: fixed;
    background-color: white;
    border-right: 2.5px solid var(--sniffer-color-border);
}

.side_menu_items {
    margin: 0;
    padding: 0;
    width: 14rem;
    display: flex;
    list-style: none;
    text-align: left;
    flex-direction: column;
    justify-content: space-evenly;
}

.side_menu_items li {
    display: flex;
    margin-top: 6px;
    min-height: 42px;
    padding-left: 24px;
    align-items: center;
    background-color: white;
}

.side_menu_items li:hover {
    cursor: pointer;
    background-color: var(--sniffer-color-border);
}

.side_menu_link,
.side_menu_link:visited {
    z-index: 5;
    text-decoration: none;
    color: var(--sniffer-color-icon-small);
}

.side_menu_link:visited {
    color: var(--sniffer-color-icon-small);
}

.icon.material-icons {
    user-select: none;
    margin-right: 10px;
    color: var(--sniffer-color-icon-small);    
}

.item_label {
    max-width: 132px;
    display: inline-block;
    font-size: var(--sniffer-font-size-15);
}

.sub_item_indicator {
    right: 0;
    position: absolute;
}

.sub_item_indicator_open {
    transform: rotate(90deg);
    transition: all 0.3s ease-out;
}

.sub_settings_wrapper {
    font-size: 14px;
    background-color: var(--sniffer-color-light-grey);
}

.sub_settings_items {
    padding-left: 6px;
}

.sub_settings_items li {
    margin-top: 0;
    min-height: 33px;
    font-size: var(--sniffer-font-size-sub-menu);
    background-color: var(--sniffer-color-light-grey);
}

.toggle {
    width: 24px;
    top: 4.5rem;
    z-index: 40;
    height: 24px;
    cursor: pointer;
    position: fixed;
    background-color: var(--sniffer-color-border);
}

.menu_button {
    top: 4.5rem;
    left: 14rem;
    z-index: 40;
    position: fixed;
}

.sub-menu-leave-from,
.sub-menu-enter-to {
    transform: translateY(0);
}

.sub-menu-leave-active {
    transition: all 0.3s ease-in;
}

.sub-menu-leave-to,
.sub-menu-enter-from {
    transform: translateY(-3rem);
}

.sub-menu-enter-active {
    transition: all 0.3s ease-out;
}

.menu-leave-from,
.menu-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.menu-leave-active {
    transition: all 0.3s ease-in;
}

.menu-leave-to,
.menu-enter-from {
    opacity: 0;
    transform: translateX(-14rem);
}

.menu-enter-active {
    transition: all 0.3s ease-out;
}

.toggle-button-leave-from,
.toggle-button-enter-to {
    transform: translateX(0);
}

.toggle-button-leave-active {
    transition: all 0.3s ease-in;
    animation: slide-left 0.3s ease-out;
}

.toggle-button-leave-to,
.toggle-button-enter-from {
    transform: translateX(-14rem);
}

.toggle-button-enter-active {
    transition: all 0.3s ease-out;
    animation: slide-right 0.3s ease-out;
}

@keyframes slide-left {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-14rem);
    }
}

@keyframes slide-right {
    0% {
        transform: translateX(-14rem);
    }

    100% {
        transform: translateX(0);
    }
}
</style>